import { type BoxProps } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { type ReactNode } from 'react'

export interface CartCardHeaderProps extends Omit<BoxProps, 'title'> {
  title?: ReactNode
  subTitle?: ReactNode
  actions?: ReactNode
}

export const CartCardHeader = (props: CartCardHeaderProps) => {
  const { title, subTitle, actions, ...rest } = props
  return (
    <HStack alignItems="center" justifyContent="space-between" p={3} pb={0} {...rest}>
      <VStack gap={1}>
        {title && <Text variant="subtitle">{title}</Text>}
        {subTitle && <Text variant="caption" color={colors.grey600}>{subTitle}</Text>}
      </VStack>
      {actions}
    </HStack>
  )
}
